"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameSessionHolder = void 0;
const Holder_1 = require("~/utils/Holder");
class GameSessionHolder extends Holder_1.Holder {
    constructor() {
        super("GameSession");
    }
}
exports.GameSessionHolder = GameSessionHolder;
